import { marketConfig } from './__MARKET__'
export { marketConfig }

export const currentMarket = marketConfig.market
